module.exports = __webpack_public_path__ + "9defdea0953114380f9bcc805cfb0441.MP3";